import React from 'react';
import { useTranslation } from 'react-i18next';
import SVGImage from '../layout/SVGImage';

interface OperationManagementPowerPlantTableProps {
  data: Array<PowerPlantListTableData>;
  testId?: string;
  className?: string;
  onClick?: () => void;
  handleDelete?: (siteId: string) => void;
  handleEdit?: (data: PowerPlantListTableData) => void;
}

export const OperationManagementPowerPlantTable: React.FC<
  OperationManagementPowerPlantTableProps
> = ({ data, testId, className, onClick, handleDelete, handleEdit }) => {
  const { t } = useTranslation();

  const headers = [
    t('management.resourceName'),
    t('management.resourceCode'),
    t('management.plantName'),
    t('management.plantType'),
    t('management.energyMarketId'),
    t('management.plantId'),
    t('management.generatorCount'),
    t('management.generatorCapacity'),
    t('management.coordinates'),
    t('management.location'),
    t('management.setting'),
  ];
  return (
    <table data-testid={testId} className={`${className} w-full`}>
      <thead>
        <tr className="h-[36px] rounded-[5px] bg-dark-4 text-white">
          {headers.map((value, index) =>
            index === 0 ? (
              <th
                key={index}
                className="pop-normal-3 rounded-bl-[5px] rounded-tl-[5px]"
              >
                {value}
              </th>
            ) : index === headers.length - 1 ? (
              <th
                key={index}
                className="pop-normal-3 rounded-br-[5px] rounded-tr-[5px]"
              >
                {value}
              </th>
            ) : (
              <th key={index} className="pop-normal-3">
                {value}
              </th>
            )
          )}
        </tr>
      </thead>
      <tbody>
        {data.map((value, index) => (
          <tr key={index} data-testid={`${testId}-item`}>
            {Object.values(value).map((value, index) => {
              const indexLimit = 10;
              const generatorNameIndex = 2;

              if (generatorNameIndex === index)
                return (
                  <td
                    onClick={() => onClick?.()}
                    data-testid={`${testId}-item-title`}
                    className="noto-normal-3 cursor-pointer border-b border-[#E2E7E7] py-[13px] text-center leading-none tracking-[-0.5px] text-blue-main underline decoration-blue-main underline-offset-2"
                    key={index}
                  >
                    {value}
                  </td>
                );
              else if (index < indexLimit)
                return (
                  <td
                    className="noto-normal-3 border-b border-[#E2E7E7] py-[13px] text-center leading-none tracking-[-0.5px] text-dark-6"
                    key={index}
                  >
                    {value}
                  </td>
                );
            })}
            <td className="pop-13-normal flex justify-center border-b border-[#E2E7E7] py-[13px] text-center leading-none text-dark-6">
              <SVGImage
                name="edit"
                className="mr-[14px] cursor-pointer"
                onClick={() => handleEdit?.(value)}
                testId={`${testId}-setting-update`}
              />
              <SVGImage
                name="delete"
                className="cursor-pointer"
                onClick={() => handleDelete?.(value.siteId)}
                testId={`${testId}-setting-delete`}
              />
            </td>
          </tr>
        ))}
      </tbody>
    </table>
  );
};
